import { render, staticRenderFns } from "./CreateProjectDetailFastDialog.vue?vue&type=template&id=fdec95b2&scoped=true&lang=pug&"
import script from "./CreateProjectDetailFastDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectDetailFastDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProjectDetailFastDialog.vue?vue&type=style&index=0&id=fdec95b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdec95b2",
  null
  
)

export default component.exports